﻿/**
 * In-Memory Mock Analytics Service
 * Connect Source Architecture
 * 
 * Captures events in memory and safely logs during development.
 */

import { AnalyticsEvent, AnalyticsEventPayloadMap, AnalyticsEventType } from '../../types/analytics';
import { IAnalyticsService } from './IAnalyticsService';

export class MockAnalyticsService implements IAnalyticsService {
  private readonly events: AnalyticsEvent[] = [];
  private anonymousId: string = `anon_${Math.random().toString(36).substring(2, 10)}`;
  private identifiedUserId?: string;

  track<T extends AnalyticsEventType>(event: T, properties: AnalyticsEventPayloadMap[T]): void {
    const record: AnalyticsEvent<T> = {
      event,
      timestamp: Date.now(),
      url: typeof window !== 'undefined' ? window.location.pathname : '/',
      properties: properties as any,
      userId: this.identifiedUserId,
      anonymousId: this.anonymousId
    };

    this.events.push(record as any);
  }

  trackPageView(path: string, title?: string): void {
    this.track('page_view', {
      path,
      title: title || (typeof document !== 'undefined' ? document.title : '')
    });
  }

  identify(userId: string): void {
    this.identifiedUserId = userId;
  }

  getEventsBuffer(): readonly AnalyticsEvent[] {
    return [...this.events];
  }

  clear(): void {
    this.events.length = 0;
  }
}

